<div
  *ngIf="!!drawerMessage?.message"
  data-cy="product-card-top-drawer-section"
  class="top-drawer"
  [class.is-warning]="drawerMessage?.isWarning"
>
  <ion-icon
    data-cy="product-card-top-drawer-icon"
    name="{{ drawerMessage?.iconName }}"
    (click)="drawerMessage?.isWarning ? null : onInfoIconClick()"
  ></ion-icon>
  <p data-cy="product-card-top-drawer-text">
    {{ drawerMessage?.message | translate }}
    <span
      *ngIf="drawerMessage?.secondaryMessage"
      data-cy="product-card-top-drawer-subtext-1"
    >
      &nbsp;{{ drawerMessage?.secondaryMessage | translate }}
    </span>
    <span
      *ngIf="drawerMessage?.secondaryMessageDate"
      data-cy="product-card-top-drawer-subtext-2"
    >
      &nbsp;{{ drawerMessage?.secondaryMessageDate }}
    </span>
  </p>
</div>

<div
  *ngIf="!drawerMessage?.message && warningMessage?.display"
  class="top-drawer is-warning"
  data-cy="product-card-top-drawer-section-alternative"
>
  <ion-icon
    data-cy="product-card-top-drawer-icon"
    name="{{ drawerMessage?.iconName ?? 'close-circle-outline' }}"
  ></ion-icon>
  <p data-cy="product-card-top-drawer-text">
    {{ warningMessage?.primaryText | translate }}
    <span
      *ngIf="warningMessage?.secondaryText"
      data-cy="product-card-top-drawer-subtext-1"
    >
      &nbsp; {{ warningMessage?.secondaryText | translate }}
    </span>
    <span
      *ngIf="warningMessage?.secondaryTextDate"
      data-cy="product-card-top-drawer-subtext-2"
    >
      &nbsp;{{ warningMessage?.secondaryTextDate }}
    </span>
  </p>
</div>
